(() => {
  const form = document.getElementById("contact_form");
  if(!form)return;
  const submit = form.querySelector('button[type="submit"]');
  if(!submit)return;
  const FLOW_KEY="leyl_contact_flow_v1";
  const API="https://leyl-contact-backend.john-karlsson-ns.workers.dev/api/contacts";
  const SITEKEY="0x4AAAAAAFVlVVP2KoIQWj1z";
  const preview=new URLSearchParams(location.search).get("preview_theme_id");
  let busy=false,loader;
  const newRequestId=()=>window.crypto?.randomUUID?.() || ("contact-"+Date.now()+"-"+Math.random().toString(36).slice(2));
  let requestId=newRequestId();
  const get=(name)=>form.elements.namedItem(name)?.value || "";
  const fields=()=>({
    firstName:get("contact[name]"),lastName:get("contact[Last name]"),
    email:get("contact[email]"),subject:get("contact[subject]"),message:get("contact[body]")
  });
  function saveFlow(phase,token){
    sessionStorage.setItem(FLOW_KEY,JSON.stringify({
      phase,token:token||null,created:Date.now(),path:location.pathname,theme:preview,
      data:fields(),requestId
    }));
  }
  function loadFlow(){
    try {
      const f=JSON.parse(sessionStorage.getItem(FLOW_KEY)||"null");
      if(f&&Date.now()-f.created<(f.phase==="retry"?86400000:240000))return f;
    }catch(e){}
    sessionStorage.removeItem(FLOW_KEY);return null;
  }
  function restore(f){
    const lookup={"contact[name]":f.data.firstName,"contact[Last name]":f.data.lastName,
      "contact[email]":f.data.email,"contact[subject]":f.data.subject,"contact[body]":f.data.message};
    Object.entries(lookup).forEach(([key,value])=>{
      const el=form.elements.namedItem(key);if(el)el.value=value||"";
    });
  }
  function message(text,error=false){
    let el=document.getElementById("leyl-contact-feedback");
    if(!el){
      el=document.createElement("div");el.id="leyl-contact-feedback";
      el.setAttribute("role",error?"alert":"status");el.style.cssText="margin:18px 0;padding:16px 20px;border:1px solid #986b55;color:#e7a17a;font:17px/1.6 Georgia,serif";
      submit.parentElement.insertAdjacentElement("afterend",el);
    }
    el.setAttribute("role",error?"alert":"status");
    el.textContent=text;
    el.tabIndex=-1;
    el.style.outline="none";
    el.style.boxShadow="none";
    window.requestAnimationFrame(()=>{
      el.scrollIntoView({behavior:"smooth",block:"center"});
      el.focus({preventScroll:true});
    });
  }
  async function loadTurnstile(){
    if(window.turnstile)return;
    if(!loader)loader=new Promise((resolve,reject)=>{
      const script=document.createElement("script");
      script.src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.onload=()=>window.turnstile?resolve():reject(new Error("Security check unavailable."));
      script.onerror=()=>reject(new Error("Security check unavailable."));
      document.head.appendChild(script);
    });
    return loader;
  }
  async function verifyAutomatically(){
    await loadTurnstile();
    return new Promise((resolve,reject)=>{
      const mount=document.createElement("div");
      // Keep Turnstile in the visible form. Offscreen rendering can
      // interfere with interactive-challenge detection.
      mount.id="leyl-contact-turnstile-mount";
      mount.style.cssText="width:300px;max-width:100%;min-height:0;margin:0 auto;display:flex;justify-content:center";
      submit.parentElement.insertAdjacentElement("afterend",mount);
      let done=false,id,timer;
      function finish(error,token){
        if(done)return;done=true;clearTimeout(timer);
        try{if(id!==undefined)window.turnstile.remove(id)}catch(e){}
        mount.remove();if(error)reject(error);else resolve(token);
      }
      try{
        id=window.turnstile.render(mount,{
          sitekey:SITEKEY,action:"contact",theme:"dark",appearance:"interaction-only",execution:"execute",
          "before-interactive-callback":()=>{
            saveFlow("challenge");
            location.assign("/pages/security-hcaptcha-preview"+(preview?"?preview_theme_id="+encodeURIComponent(preview):""));
            finish(null,null);
          },
          callback:token=>finish(null,token),
          "error-callback":()=>finish(new Error("Security verification failed. Please try again.")),
          "timeout-callback":()=>finish(new Error("Security verification timed out.")),
          "expired-callback":()=>finish(new Error("Security verification expired."))
        });
        timer=setTimeout(()=>finish(new Error("Security verification timed out.")),30000);
        window.turnstile.execute(id);
      }catch(e){finish(new Error("Security check unavailable."))}
    });
  }
  async function send(token){
    busy=true;submit.disabled=true;
    const original=submit.textContent;submit.textContent="Sending...";
    try{
      if(!token){token=await verifyAutomatically();if(!token)return}
      const response=await fetch(API,{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({...fields(),turnstileToken:token,requestId})});
      const result=await response.json().catch(()=>({}));
      if(!response.ok||!result.ticketId)throw new Error(result.error||"Could not send your message.");
      sessionStorage.removeItem(FLOW_KEY);
      requestId=newRequestId();
      form.reset();
      message("Thank you. Your message "+result.ticketId+" has been received. Our team aims to reply within 24 hours.");
    }catch(err){message(err?.message||"Could not send your message. Please try again.",true)}
    finally{busy=false;submit.disabled=false;submit.textContent=original}
  }
  form.addEventListener("submit",event=>{
    event.preventDefault();event.stopImmediatePropagation();
    if(busy||!form.reportValidity())return;
    saveFlow("draft");
    send(null);
  },true);
  const flow=loadFlow();
  if(flow){
    requestId=flow.requestId||requestId;
    restore(flow);
    if(flow.phase==="verified"&&flow.token){
      sessionStorage.setItem(FLOW_KEY,JSON.stringify({...flow,phase:"submitting",token:null}));
      send(flow.token);
    }
  }
})();
